module.exports = __webpack_public_path__ + "img/comment-white-oval-bubble.2aae285c.png";